var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[(_vm.user.role == 'ADMIN')?[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('table-rows')],1)]:_vm._e(),(_vm.user.role == 'USER')?[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('processing-offers')],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }